import {Component, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";

@Component({
    selector: 'hc-integration-object-base-component',
    templateUrl: 'integration-type-object-base.component.html',
    styleUrls: ['integration-type-object-base.component.scss'],
    standalone: false
})

export class IntegrationTypeObjectBaseComponent extends ObjectBaseComponent implements OnInit, OnChanges {

    name: string = "Integration Type Object";

    ngOnInit() {
        this.initialized = true;
        this.handleName(this.name);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

}